import { render, staticRenderFns } from "./common-bulk-message-list-item.vue?vue&type=template&id=51d2ec6e"
import script from "./common-bulk-message-list-item.vue?vue&type=script&lang=js"
export * from "./common-bulk-message-list-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51d2ec6e')) {
      api.createRecord('51d2ec6e', component.options)
    } else {
      api.reload('51d2ec6e', component.options)
    }
    module.hot.accept("./common-bulk-message-list-item.vue?vue&type=template&id=51d2ec6e", function () {
      api.rerender('51d2ec6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/send-list/list/common-bulk-message-list/common-bulk-message-list-item.vue"
export default component.exports